import { ApiPostRequest } from 'src/app/model/api/api-request/api-post-request';

export class UpsaleNeighbourTicketReservationRequest extends ApiPostRequest
{
    public constructor(playerId: number, ticketNumber: number, webapiBasepath: string)
    {
        super(
            'upsale/ticketreservation/Neighbour',
            null,
            null,
            {
                'PlayerId': playerId,
                'TicketNumber': ticketNumber
            },
            webapiBasepath
        );
    }
}
